import React, { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import "../styles/components/SelectOption.scss";
import ValidationError from "./ValidationError";
import { SingleSelect } from "@els/els-react--select";

const LeydenSelect = (props: any) => {
  const [selected, setSelected] = useState(
    props.defaultSelected !== "" ? [props.defaultSelected] : []
  );

  const handleOnChange = (e: any) => {
    setSelected([e.value]);
    props.onChange(e);
  };

  const optionsHasValue = (value: any): boolean => {
    return value.value == props.defaultSelected;
  }

  // Validating if the selected value belongs to the list of options
  const isValidSelectedValue = props.options.some(optionsHasValue);

  useEffect(() => {
    (props.defaultSelected !== "" && isValidSelectedValue)
      ? setSelected([props.defaultSelected])
      : setSelected([]);
  }, [props?.defaultSelected]);

  return (
    <>
      <div className="selectOption">
        <label className="label-1">
          {props?.label_key ? (
            <>
              <Trans i18nKey={props?.label_key}></Trans>{" "}
              {props?.mandate && <span className="mandetory">*</span>}
            </>
          ) : (
            props.label
          )}
        </label>

        <SingleSelect
          label={props.label ?? ""}
          options={props.options}
          selectedOptions={selected}
          // onSelect={function(e){console.log("Select changed",e)}}
          // validator={function(e){return 2===e[0]?"Option two is invalid":null}}
          // onMountValidation={function(e){console.log("single select onMountValidation",e)}}
          isLabelInline={false}
          //blankOptionLabel={props.blankOptionLabel}
          placeholderText={props.blankOptionLabel}
          onSelect={handleOnChange}
          shouldHideLabel={true}
          id={props.id ?? ""}
        />
      </div>
      <ValidationError error_key={props?.error} />
    </>
  );
};

export default LeydenSelect;
